import React, {Fragment} from 'react';
import MediaViewer from '../../MediaViewer';
import ImageRotation from '../../ImageRotation';
import Icon from '../../Icon';
import {apiCropImage} from '../../../../config';
import Modal from "../../Modal";


class OneThumbTimeline extends React.Component {
    static defaultProps = {
        title: "",
        slug: '',
        count: {
            view: 0,
            like: 0,
        },
        fileName: {
            url: ""
        },
        owner: {
            _id: 0,
            slug: '',
            username: '',
            avatar: "",
            gender: ""
        },
        currentUser: {
            _id: 1,
        },
        authorName: "",
        videoCoverUrl : ""
    };

    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            imageLoading: true,
        };

        this.handleImageLoaded = this.handleImageLoaded.bind(this);
    }

    handleImageLoaded() {
        this.setState({imageLoading: false});
    }

    render() {
        let mediaType = this.props.kind;
        let isVideo = mediaType === 'video' ? 'thumb-video' : '';
        let loadingClass = mediaType === 'video' ? 'loading thumb-video' : 'loading';
        let thumbnailWidth = mediaType === 'video' ? 500 : 500;
        let thumbnailHeight = mediaType === 'video' ? 375 : 500;
        //Todo : Taille thumb timeline
        return (
            <Fragment>
                <div className={`one-thumb-timeline ${this.state.imageLoading ? loadingClass : ''}`}
                     onClick={() => !this.state.imageLoading && this.setState({toggle: true})}>
                    <div className={`thumb ${isVideo}`}>
                        <div className={`thumb-wrapper ${this.state.imageLoading ? loadingClass : 'loaded'}`}>
                            {mediaType === "video" ? (

                                <Fragment>
                                    <ImageRotation
                                        srcs={Array.isArray(this.props.previewUrl) && this.props.previewUrl.map(src => apiCropImage({
                                            url: src,
                                            width: thumbnailWidth,
                                            height: thumbnailHeight
                                        }))}
                                        videoCoverUrl={this.props.videoCoverUrl ? `${this.props.videoCoverUrl}?width=${thumbnailWidth}&height=${thumbnailHeight}&quality=80` : ""}
                                        onLoad={() => this.handleImageLoaded()}
                                        onError={() => this.setState({imageLoading: true})}
                                        interval={600}
                                        alt={this.props.title}
                                    />
                                    <div className="btn-play">
                                        <Icon type="play"/>
                                    </div>
                                </Fragment>
                            ) : (
                                <img
                                    src={apiCropImage({
                                        url: this.props.previewUrl,
                                        width: thumbnailWidth,
                                        height: thumbnailHeight
                                    })}
                                    onLoad={() => this.handleImageLoaded()}
                                    onError={() => this.setState({imageLoading: true})}
                                    alt={this.props.title}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <Modal toggle={this.state.toggle} handleClose={() => this.setState({toggle: false})}>
                    <MediaViewer mediaId={this.props._id} mediaSlug={this.props.slug} handleClose={() => this.setState({toggle: false})}/>
                </Modal>
            </Fragment>
        )
    }
}

export default OneThumbTimeline;
